import script from "./Event.vue?vue&type=script&setup=true&lang=ts"
export * from "./Event.vue?vue&type=script&setup=true&lang=ts"

import "./Event.vue?vue&type=style&index=0&id=60c4d36f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60c4d36f"]])

export default __exports__